// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/stability.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/stability/stability.js';

mount([g0]);
